import type { AxiosPromise } from 'axios';
import BaseClient from '../BaseClient';
import type {
    LifecycleStatusDefinitionFormData,
    LifecycleStatusDefinitionsClientInterface,
    LifecycleStatusDefinitionsResponse,
} from './lifecycleStatusDefinitionsClient.types';

export default class CorporateLifecycleStatusDefinitionsClient
    extends BaseClient
    implements LifecycleStatusDefinitionsClientInterface
{
    constructor(private teamId: number) {
        super();
    }

    getLifecycleStatusDefinitions(): AxiosPromise<LifecycleStatusDefinitionsResponse> {
        const url = `/api/v3/teams/${this.teamId}/lifecycle-status-definitions`;
        return this.makeCoreApiRequest(url, 'get');
    }

    updateLifecycleStatusDefinitions(
        data: { definitions: LifecycleStatusDefinitionFormData[] },
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<LifecycleStatusDefinitionsResponse> {
        const url = `/api/v3/teams/${this.teamId}/lifecycle-status-definitions`;
        return this.makeCoreApiRequest(url, 'put', data, null, extraConfig);
    }
}
